<template>
    <div class="app">
        <scroll @refresh="refresh">
            <no-record :condition="voucherList" tips='请先添加就诊人'></no-record>
            <voucher-item :id="'profile-voucherItem-' + voucher.cardNo" class="voucher-list"
                          v-for="(voucher, index) in voucherList" :key="index"
                          :class="(0 == index) ? 'selected' : ''" :voucher="voucher" :edit="0"
                          @selected="selectVoucher(voucher, index, $event)" :is-frequent="index === 0"></voucher-item>
        </scroll>
    </div>
</template>
<script>
import voucherService from 'voucher.service'
import VoucherItem from '../voucher/VoucherItem'
import NoRecord from 'NoRecord';
export default {
    components: {
        VoucherItem,
        NoRecord
    },
    data() {
        return {
            voucherList: []
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            voucherService.getVoucherList().then((res) => {
                if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                    this.$utils.alert(res.resultMsg);
                    return;
                }
                this.voucherList = res.data;
            });
        },
        selectVoucher(voucher) {
            this.$store.commit('updateParam', {
                namespace: 'healthRecord',
                voucher: voucher
            });
            this.$router.push('RecordSelect');
        },
    }
}
</script>



// WEBPACK FOOTER //
// VoucherSelect.vue?ab7f571e